require("!!D:\\Heny Fitriani\\Project GitLab\\CWT\\cwtonlineportal\\Infolog.UI.Web\\node_modules\\script-loader\\addScript.js")(require("!!D:\\Heny Fitriani\\Project GitLab\\CWT\\cwtonlineportal\\Infolog.UI.Web\\node_modules\\raw-loader\\index.js!D:\\Heny Fitriani\\Project GitLab\\CWT\\cwtonlineportal\\Infolog.UI.Web\\node_modules\\source-map-loader\\index.js!D:\\Heny Fitriani\\Project GitLab\\CWT\\cwtonlineportal\\Infolog.UI.Web\\src\\assets\\plugins\\floatmenu\\velocity.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/assets/plugins/floatmenu/velocity.min.js
// module id = 536
// module chunks = 9